module.exports = __webpack_public_path__ + "static/media/twitter.de6c2930.svg";